import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useInView } from '../../../hooks/useInView';
import appStoreImg from '../../../assets/new-design/appstore.png';
import googlePlayImg from '../../../assets/new-design/googleplay.png';
import './CTAFooterSection.scss';

export function CTAFooterSection() {
  const navigate = useNavigate();
  const { ref, inView } = useInView<HTMLDivElement>({ threshold: 0.15 });

  return (
    <section className="cta-footer-section">
      <div
        className={`cta-footer-section__inner animate-on-scroll${inView ? ' is-visible' : ''}`}
        ref={ref}
      >
        <div>
          <h2 className="cta-footer-section__left-title">
            Baixe o app e comece a lavar sem fila
          </h2>
          <p className="cta-footer-section__left-subtitle">
            Disponível para Android e iOS.
          </p>
          <div className="cta-footer-section__app-buttons">
            <a
              href="https://apps.apple.com/br/app/washpass/id6503068980"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={appStoreImg} alt="Download on the App Store" className="cta-footer-section__app-img" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=washpass.app&hl=pt_BR"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googlePlayImg} alt="Get it on Google Play" className="cta-footer-section__app-img" />
            </a>
          </div>
        </div>

        <div className="cta-footer-section__partner-box">
          <div className="cta-footer-section__partner-title">Tem um lava-rápido?</div>
          <p className="cta-footer-section__partner-desc">
            Cadastre-se na rede e receba clientes assinantes todos os dias.
          </p>
          <button
            className="cta-footer-section__partner-btn"
            onClick={() => navigate('/parceiros')}
          >
            Seja parceiro
          </button>
        </div>
      </div>
    </section>
  );
}
